/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './createAppPassword.defs'
export { main as default } from './createAppPassword.defs'
